import { component as defineComponent } from 'flightjs';

function like() {
    this.attributes({
        likeCounter: '[data-like-count]',
        likeUrl: '[data-like-url]',
        unlikeUrl: '[data-unlike-url]',
        designId: '[data-design-id]',
    });

    this.getDataUrl = function(attr) {
        var element = this.select(attr);
        return element.attr(this.attr[attr].replace(/[\[\]]+/g, ''));
    };

    this.getDesignId = function(e) {
        return this.select('designId').data('design-id');
    };

    this.getLikers = function(e) {
        var xhr = $.ajax({
            type: 'GET',
            url: this.select('likeCounter').data('url'),
            dataType: 'html',
        });
        xhr.done(
            function(data) {
                this.trigger('dataLikersUpdated', [data]);
            }.bind(this)
        );
    };

    this.like = function(e) {
        var xhr = $.ajax({
            type: 'POST',
            url: this.getDataUrl('likeUrl'),
            data: { designId: this.getDesignId() },
        });

        xhr.done(
            function(res) {
                this.trigger('dataEntryLiked');
            }.bind(this)
        );
    };

    this.unlike = function(e) {
        var xhr = $.ajax({
            url: this.getDataUrl('unlikeUrl'),
            type: 'DELETE',
        });

        xhr.done(
            function(data) {
                this.trigger('dataEntryUnliked');
            }.bind(this)
        );
    };

    this.after('initialize', function() {
        this.on('uiLikeEntryRequested', this.like);
        this.on('uiUnlikeEntryRequested', this.unlike);
        this.on('uiUpdateLikeListRequested', this.getLikers);
    });
}

export default defineComponent(like);



// WEBPACK FOOTER //
// ./src/web/js/entry/data/like.js